module.exports = __webpack_public_path__ + "img/困.5b0f98e3.gif";